import React from "react";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import headerPortalIcon from "@assets/header-portal-icon.svg";
import { SIDEBAR_EXPANDED_WIDTH_PX } from "@config/theme/tokens";
import "./Header.css";

const Header = React.memo(() => {
	return (
		<header
			className="app-header sticky top-0 z-30 flex items-center justify-between"
			style={{ marginLeft: `${SIDEBAR_EXPANDED_WIDTH_PX}px` }}>
			<div className="flex min-w-0 items-center gap-2.5 sm:gap-3">
				<img
					src={headerPortalIcon}
					alt=""
					className="h-[2.0625rem] w-[2.3125rem] shrink-0"
					aria-hidden="true"
				/>
				<h1 className="header-branding__title truncate font-sans text-foreground">
					Employer Portal
				</h1>
			</div>
			<div className="flex shrink-0 items-center gap-2 sm:gap-3">
				<div className="header-action-circle">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
